import React from "react";

interface Props {
  className?: string;
}

export const SettingsIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1285_942)">
        <g clipPath="url(#clip1_1285_942)">
          <path
            d="M7.46458 1.95725C7.85508 0.347583 10.1449 0.347583 10.5354 1.95725C10.594 2.19907 10.7089 2.42363 10.8707 2.61267C11.0324 2.8017 11.2366 2.94987 11.4664 3.0451C11.6963 3.14033 11.9454 3.17995 12.1935 3.16071C12.4415 3.14148 12.6816 3.06394 12.894 2.93442C14.3084 2.07275 15.9282 3.69158 15.0665 5.10692C14.9372 5.31927 14.8597 5.55914 14.8406 5.80704C14.8214 6.05494 14.8609 6.30387 14.9561 6.5336C15.0512 6.76332 15.1992 6.96736 15.388 7.12913C15.5768 7.2909 15.8012 7.40583 16.0428 7.46458C17.6524 7.85508 17.6524 10.1449 16.0428 10.5354C15.8009 10.594 15.5764 10.7089 15.3873 10.8707C15.1983 11.0324 15.0501 11.2366 14.9549 11.4664C14.8597 11.6963 14.8201 11.9454 14.8393 12.1935C14.8585 12.4415 14.9361 12.6816 15.0656 12.894C15.9273 14.3084 14.3084 15.9282 12.8931 15.0665C12.6807 14.9372 12.4409 14.8597 12.193 14.8406C11.9451 14.8214 11.6961 14.8609 11.4664 14.9561C11.2367 15.0512 11.0326 15.1992 10.8709 15.388C10.7091 15.5768 10.5942 15.8012 10.5354 16.0428C10.1449 17.6524 7.85508 17.6524 7.46458 16.0428C7.40599 15.8009 7.29113 15.5764 7.12935 15.3873C6.96757 15.1983 6.76344 15.0501 6.53357 14.9549C6.3037 14.8597 6.0546 14.8201 5.80653 14.8393C5.55846 14.8585 5.31844 14.9361 5.106 15.0656C3.69158 15.9273 2.07183 14.3084 2.9335 12.8931C3.06284 12.6807 3.14025 12.4409 3.15944 12.193C3.17863 11.9451 3.13906 11.6961 3.04393 11.4664C2.94881 11.2367 2.80082 11.0326 2.612 10.8709C2.42318 10.7091 2.19885 10.5942 1.95725 10.5354C0.347583 10.1449 0.347583 7.85508 1.95725 7.46458C2.19907 7.40599 2.42363 7.29113 2.61267 7.12935C2.8017 6.96757 2.94987 6.76344 3.0451 6.53357C3.14033 6.3037 3.17995 6.0546 3.16071 5.80653C3.14148 5.55846 3.06394 5.31844 2.93442 5.106C2.07275 3.69158 3.69158 2.07183 5.10692 2.9335C6.02358 3.49083 7.21158 2.99767 7.46458 1.95725Z"
            stroke="#C3CFE7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.24981 8.99982C6.24981 9.72916 6.53954 10.4286 7.05527 10.9444C7.57099 11.4601 8.27046 11.7498 8.99981 11.7498C9.72915 11.7498 10.4286 11.4601 10.9444 10.9444C11.4601 10.4286 11.7498 9.72916 11.7498 8.99982C11.7498 8.27047 11.4601 7.571 10.9444 7.05527C10.4286 6.53955 9.72915 6.24982 8.99981 6.24982C8.27046 6.24982 7.57099 6.53955 7.05527 7.05527C6.53954 7.571 6.24981 8.27047 6.24981 8.99982Z"
            stroke="#C3CFE7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1285_942">
          <rect width="18" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_1285_942">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
